import React from 'react';
import { Empty } from 'antd';
import CampaignStatsPage from '../../pages/CampaignStatsPage';

/**
 * Call volume, SLA and handle time for the campaign, rendered by the page that already computes it.
 *
 * Not a reimplementation: the Campaign Summary is a hub, so this scopes the
 * existing page to the chosen campaign rather than growing a second query for
 * the same numbers. A fix to that page lands here too, and the two cannot
 * drift into disagreeing.
 *
 * Keyed on CXCampaignNo, not the app's Campaigns.ID -- the campaign-stats
 * endpoints take the CX number.
 *
 * No window label here: two of that page's views ignore the range -- Single
 * Date picks a day, By Month always covers six -- and only the page knows
 * which is showing. It prints its own.
 */
export default function CallStatsTab({ campaign, from, to, skills }) {
  const cx = campaign?.CXCampaignNo;
  if (!cx) {
    return (
      <Empty
        description="This campaign has no CX campaign number, so call data cannot be looked up for it"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        style={{ marginTop: 40 }}
      />
    );
  }
  return (
    <>
    <CampaignStatsPage
      embedded
      filters={{ campaign: String(cx), start_date: from, end_date: to, ...(skills ? { skill: skills.join(',') } : {}) }}
    />
    </>
  );
}
